/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  InviteOrganizationResponseData,
  InviteOrganizationResponseDataFromJSON,
  InviteOrganizationResponseDataFromJSONTyped,
  InviteOrganizationResponseDataToJSON
} from './InviteOrganizationResponseData'

/**
 *
 * @export
 * @interface InviteOrganizationResponse
 */
export interface InviteOrganizationResponse {
  /**
   *
   * @type {number}
   * @memberof InviteOrganizationResponse
   */
  status: number
  /**
   *
   * @type {InviteOrganizationResponseData}
   * @memberof InviteOrganizationResponse
   */
  data: InviteOrganizationResponseData
}

export function InviteOrganizationResponseFromJSON(json: any): InviteOrganizationResponse {
  return InviteOrganizationResponseFromJSONTyped(json, false)
}

export function InviteOrganizationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InviteOrganizationResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: InviteOrganizationResponseDataFromJSON(json['data'])
  }
}

export function InviteOrganizationResponseToJSON(value?: InviteOrganizationResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: InviteOrganizationResponseDataToJSON(value.data)
  }
}
